import styled from 'styled-components';

export const Root = styled.div`
  background: ${({ theme }) => (theme.isDarkMode ? '#99999933' : '#ffffffaa')};
  padding: ${({ theme }) => (!theme.isDarkMode ? theme.shape.spacing(5) : '0')};
  border-radius: ${({ theme }) => theme.shape.borderRadius};
`;
